export const cs = {
  // Navigation
  dashboard: 'Nástěnka',
  invoices: 'Faktury',
  aboFiles: 'ABO soubory',
  users: 'Uživatelé',
  profile: 'Profil',
  logout: 'Odhlásit se',
  login: 'Přihlásit se',

  // Common
  save: 'Uložit',
  cancel: 'Zrušit',
  delete: 'Smazat',
  edit: 'Upravit',
  view: 'Zobrazit',
  add: 'Přidat',
  search: 'Hledat',
  filter: 'Filtr',
  clear: 'Vymazat',
  loading: 'Načítání...',
  error: 'Chyba',
  success: 'Úspěch',
  warning: 'Varování',
  info: 'Informace',
  confirm: 'Potvrdit',
  back: 'Zpět',
  next: 'Další',
  previous: 'Předchozí',
  close: 'Zavřít',
  open: 'Otevřít',
  download: 'Stáhnout',
  upload: 'Nahrát',
  export: 'Exportovat',
  import: 'Importovat',
  refresh: 'Obnovit',
  settings: 'Nastavení',
  help: 'Nápověda',
  about: 'O aplikaci',

  // Status
  status: {
    new: 'Nový',
    pending: 'Čeká na zpracování',
    approved: 'Schváleno',
    reviewed: 'Zkontrolováno',
    ready_for_payment: 'Připraveno k platbě',
    sent_to_bank: 'Odesláno do banky',
    paid: 'Zaplaceno',
    rejected: 'Zamítnuto'
  },

  // Invoice
  invoice: {
    title: 'Faktura',
    number: 'Číslo faktury',
    date: 'Datum faktury',
    dueDate: 'Datum splatnosti',
    supplier: 'Dodavatel',
    customer: 'Odběratel',
    amount: 'Částka',
    total: 'Celkem',
    subtotal: 'Mezisoučet',
    vat: 'DPH',
    currency: 'Měna',
    status: 'Stav',
    notes: 'Poznámky',
    items: 'Položky',
    description: 'Popis',
    quantity: 'Množství',
    unitPrice: 'Jednotková cena',
    totalPrice: 'Celková cena',
    vatRate: 'Sazba DPH',
    vatAmount: 'Částka DPH',
    supplierName: 'Název dodavatele',
    supplierAddress: 'Adresa dodavatele',
    supplierIco: 'IČO dodavatele',
    supplierDic: 'DIČ dodavatele',
    supplierBankAccount: 'Bankovní účet dodavatele',

    supplierIban: 'IBAN dodavatele',
    supplierSwift: 'SWIFT dodavatele',
    customerName: 'Název odběratele',
    customerAddress: 'Adresa odběratele',
    customerIco: 'IČO odběratele',
    customerDic: 'DIČ odběratele',
    customerBankAccount: 'Bankovní účet odběratele',

    customerIban: 'IBAN odběratele',
    customerSwift: 'SWIFT odběratele',
    pdfPath: 'Cesta k PDF',
    xmlData: 'XML data',
    assignedTo: 'Přiřazeno k',
    createdAt: 'Vytvořeno',
    updatedAt: 'Aktualizováno',
    processingStatus: 'Stav zpracování',
    tabs: {
      basicInfo: 'Základní údaje',
      supplier: 'Dodavatel', 
      customer: 'Odběratel',
      items: 'Položky',
      documents: 'Dokumenty'
    },
    supplierInfo: 'Informace o dodavateli',
    supplierBankInfo: 'Bankovní údaje dodavatele',
    customerInfo: 'Informace o odběrateli',
    customerBankInfo: 'Bankovní údaje odběratele',
    documentsInfo: 'Informace o dokumentech',
    pdfPreview: 'PDF náhled',
    pdfFile: 'PDF soubor',
    isdocPath: 'ISDOC cesta',
    bankAccount: 'Bankovní účet (číslo/kód)',
    bankCode: 'Kód banky',
    notAssigned: 'Nepřiřazeno',
    unknown: 'Neznámé',
    aboFile: 'ABO soubor'
  },

  // ABO
  abo: {
    title: 'ABO soubor',
    name: 'Název souboru',
    bank: 'Banka',
    status: 'Stav',
    createdAt: 'Vytvořeno',
    updatedAt: 'Aktualizováno',
    records: 'Záznamy',
    totalAmount: 'Celková částka',
    recordCount: 'Počet záznamů',
    generate: 'Vygenerovat',
    send: 'Odeslat',
    download: 'Stáhnout',
    banks: {
      fio: 'FIO banka',
      csob: 'ČSOB',
      kb: 'Komerční banka'
    }
  },

  // User
  user: {
    title: 'Uživatel',
    name: 'Jméno',
    email: 'E-mail',
    role: 'Role',
    password: 'Heslo',
    confirmPassword: 'Potvrdit heslo',
    firstName: 'Jméno',
    lastName: 'Příjmení',
    createdAt: 'Vytvořen',
    updatedAt: 'Aktualizován',
    lastLogin: 'Poslední přihlášení',
    roles: {
      admin: 'Administrátor',
      user: 'Uživatel'
    }
  },

  // Auth
  auth: {
    login: 'Přihlášení',
    logout: 'Odhlášení',
    register: 'Registrace',
    email: 'E-mail',
    password: 'Heslo',
    rememberMe: 'Zapamatovat si mě',
    forgotPassword: 'Zapomenuté heslo',
    resetPassword: 'Obnovit heslo',
    changePassword: 'Změnit heslo',
    oldPassword: 'Staré heslo',
    newPassword: 'Nové heslo',
    confirmNewPassword: 'Potvrdit nové heslo',
    loginSuccess: 'Přihlášení úspěšné',
    loginError: 'Chyba při přihlašování',
    logoutSuccess: 'Odhlášení úspěšné',
    logoutError: 'Chyba při odhlašování'
  },

  // Dashboard
  dashboardPage: {
    title: 'Nástěnka',
    welcome: 'Vítejte v Invoice Factory',
    stats: {
      totalInvoices: 'Celkem faktur',
      pendingInvoices: 'Čekající faktury',
      paidInvoices: 'Zaplacené faktury',
      totalAmount: 'Celková hodnota',
      thisMonth: 'Tento měsíc',
      lastMonth: 'Minulý měsíc'
    },
    recentInvoices: 'Poslední faktury',
    recentABOFiles: 'Poslední ABO soubory',
    quickActions: 'Rychlé akce',
    viewAllInvoices: 'Zobrazit všechny faktury',
    viewAllABOFiles: 'Zobrazit všechny ABO soubory',
    createABOFile: 'Vytvořit ABO soubor'
  },

  // Messages
  messages: {
    // Success
    saveSuccess: 'Úspěšně uloženo',
    deleteSuccess: 'Úspěšně smazáno',
    updateSuccess: 'Úspěšně aktualizováno',
    createSuccess: 'Úspěšně vytvořeno',
    uploadSuccess: 'Úspěšně nahráno',
    downloadSuccess: 'Úspěšně staženo',
    exportSuccess: 'Úspěšně exportováno',
    importSuccess: 'Úspěšně importováno',

    // Errors
    saveError: 'Chyba při ukládání',
    deleteError: 'Chyba při mazání',
    updateError: 'Chyba při aktualizaci',
    createError: 'Chyba při vytváření',
    uploadError: 'Chyba při nahrávání',
    downloadError: 'Chyba při stahování',
    exportError: 'Chyba při exportu',
    importError: 'Chyba při importu',
    networkError: 'Chyba připojení',
    serverError: 'Chyba serveru',
    validationError: 'Chyba validace',
    authenticationError: 'Chyba autentifikace',
    authorizationError: 'Chyba autorizace',
    notFoundError: 'Nenalezeno',
    forbiddenError: 'Zakázáno',

    // Confirmations
    deleteConfirm: 'Opravdu chcete smazat tento záznam?',
    logoutConfirm: 'Opravdu se chcete odhlásit?',
    unsavedChanges: 'Máte neuložené změny. Opravdu chcete pokračovat?',
    cancelConfirm: 'Opravdu chcete zrušit tuto akci?',

    // Info
    noData: 'Žádná data',
    noResults: 'Žádné výsledky',
    loading: 'Načítání...',
    processing: 'Zpracování...',
    uploading: 'Nahrávání...',
    downloading: 'Stahování...',
    exporting: 'Exportování...',
    importing: 'Importování...'
  },

  // Validation
  validation: {
    required: 'Toto pole je povinné',
    email: 'Zadejte platný e-mail',
    minLength: 'Minimální délka je {length} znaků',
    maxLength: 'Maximální délka je {length} znaků',
    passwordMatch: 'Hesla se neshodují',
    invalidFormat: 'Neplatný formát',
    invalidValue: 'Neplatná hodnota',
    numberRequired: 'Zadejte číslo',
    positiveNumber: 'Zadejte kladné číslo',
    dateRequired: 'Zadejte datum',
    futureDate: 'Datum musí být v budoucnosti',
    pastDate: 'Datum musí být v minulosti'
  },

  // Date and Time
  dateTime: {
    today: 'Dnes',
    yesterday: 'Včera',
    tomorrow: 'Zítra',
    thisWeek: 'Tento týden',
    lastWeek: 'Minulý týden',
    thisMonth: 'Tento měsíc',
    lastMonth: 'Minulý měsíc',
    thisYear: 'Tento rok',
    lastYear: 'Minulý rok',
    format: {
      short: 'dd.MM.yyyy',
      long: 'dd.MM.yyyy HH:mm',
      time: 'HH:mm',
      date: 'dd.MM.yyyy'
    }
  },

  // Currency
  currency: {
    czk: 'Kč',
    eur: '€',
    usd: '$',
    format: {
      czk: '{amount} Kč',
      eur: '€{amount}',
      usd: '${amount}'
    }
  },

  // Pagination
  pagination: {
    page: 'Stránka',
    of: 'z',
    showing: 'Zobrazuji',
    to: 'do',
    ofTotal: 'z celkem',
    items: 'položek',
    previous: 'Předchozí',
    next: 'Další',
    first: 'První',
    last: 'Poslední'
  },

  // Actions
  actions: {
    view: 'Zobrazit',
    edit: 'Upravit',
    delete: 'Smazat',
    duplicate: 'Duplikovat',
    export: 'Exportovat',
    import: 'Importovat',
    print: 'Tisk',
    share: 'Sdílet',
    bookmark: 'Označit',
    favorite: 'Oblíbené',
    archive: 'Archivovat',
    restore: 'Obnovit',
    approve: 'Schválit',
    reject: 'Zamítnout',
    assign: 'Přiřadit',
    unassign: 'Odebrat přiřazení',
    lock: 'Zamknout',
    unlock: 'Odemknout',
    activate: 'Aktivovat',
    deactivate: 'Deaktivovat',
    enable: 'Povolit',
    disable: 'Zakázat',
    start: 'Spustit',
    stop: 'Zastavit',
    pause: 'Pozastavit',
    resume: 'Pokračovat',
    cancel: 'Zrušit',
    confirm: 'Potvrdit',
    save: 'Uložit',
    apply: 'Použít',
    reset: 'Obnovit',
    clear: 'Vymazat',
    search: 'Hledat',
    filter: 'Filtr',
    sort: 'Řadit',
    refresh: 'Obnovit',
    reload: 'Znovu načíst',
    back: 'Zpět',
    forward: 'Vpřed',
    home: 'Domů',
    settings: 'Nastavení',
    help: 'Nápověda',
    about: 'O aplikaci',
    contact: 'Kontakt',
    support: 'Podpora',
    feedback: 'Zpětná vazba',
    report: 'Nahlásit problém',
    bug: 'Nahlásit chybu',
    feature: 'Požádat o funkci'
  }
}; 